import { Tween, Easing } from '@tweenjs/tween.js';
export class TweenBonusRound {
	constructor(character, character_blur, vc) {
		this.character = character;
		this.character_blur = character_blur;
		this.vc = vc;
		this.tween = null;
		this.tweenCharacter = null;
		this.tweenItem = null;
	}
	animateCharacterTween() {
		this.character.x = 85;
		this.character.y = -55;
		this.character_blur.x = 85;
		this.character_blur.y = -55;
		this.character.alpha = 1;
		this.character_blur.alpha = 0;
		this.character.gotoAndPlay(0);
		this.tweenCharacter = new Tween(this.character)
			.to({ y: this.character.y - 10, rotation: -0.08 }, 2000)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.start();
	}

	moveCharacterTween(x, y, item) {
		this.character.alpha = 0;
		this.character_blur.alpha = 1;
		this.character_blur.gotoAndPlay(0);
		// this.character_blur.alpha = 1;
		// this.character_blur.gotoAndPlay(0);
		// this.character_blur.x = x;
		// this.character_blur.y = y;
		this.character.x = x;
		this.character.y = y;
		setTimeout(() => {
			this.character.x = x;
			this.character.y = y;
			this.character_blur.x = x;
			this.character_blur.y = y;
			this.character.alpha = 1;
			this.character.gotoAndPlay(0);
			this.character_blur.alpha = 0;

			if (this.tweenCharacter) {
				this.tweenCharacter.stop();
				this.tweenCharacter = new Tween(this.character)
					.to({ y: this.character.y - 10, rotation: -0.08 }, 2000)
					.easing(Easing.Sinusoidal.InOut)
					.yoyo(true)
					.repeat(Infinity)
					.start();
			}
			if (item.parent.config.name === 'bonus_item_3') {
				this.animateTexts(
					this.vc.BonusItems.bonus_item_holder.bonus_item_3.text_wrapper
				);
			}
			if (item.parent.config.name === 'bonus_item_6') {
				this.animateTexts(
					this.vc.BonusItems.bonus_item_holder.bonus_item_6.text_wrapper
				);
			}
		}, 300);
	}

	animateItemsTween(item) {
		this.tweenItem = new Tween(item)
			.to({ rotation: +0.2 }, 50)
			.yoyo(true)
			.repeat(5)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				new Tween(item.scale)
					.to({ x: 0, y: 0 }, 100)
					.easing(Easing.Linear.None)
					.start();
			})
			.start();
	}

	animateTexts(item) {
		new Tween(item)
			.to({ alpha: 0 }, 200)
			.yoyo(true)
			.repeat(5)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				new Tween(item)
					.to({ alpha: 0 }, 200)
					.easing(Easing.Linear.None)
					.start();
			})
			.start();
	}

	initBonusItemsTween(items) {
		const time = 1000;
		this.vc.win_bg_wrapper.win_bg.x = -10;
		this.vc.win_bg_wrapper.win_bg.y = -10;

		new Tween(items.bonus_item_1)
			.to({ y: -20 }, time)
			.easing(Easing.Back.InOut)
			.start();
		new Tween(items.bonus_item_2)
			.to({ y: -50 }, time)
			.easing(Easing.Back.InOut)
			.delay(100)
			.start();
		new Tween(items.bonus_item_3)
			.to({ y: -70 }, time)
			.easing(Easing.Back.InOut)
			.delay(200)
			.start();
		new Tween(items.bonus_item_4)
			.to({ y: -20 }, time)
			.easing(Easing.Back.InOut)
			.delay(50)
			.start();
		new Tween(items.bonus_item_5)
			.to({ y: -40 }, time)
			.easing(Easing.Back.InOut)
			.delay(50)
			.start();
		new Tween(items.bonus_item_6)
			.to({ y: -60 }, time)
			.easing(Easing.Back.InOut)
			.delay(50)
			.onComplete(() => {
				window.connectionProvider.bonusRoundStep(
					JSON.stringify({
						service: 'bonusstep',
						data: {}
					})
				);
			})
			.start();
	}
}
